import { createTheme, useTheme } from "@mui/material/styles";

declare module "@mui/material/styles" {
  interface PaletteOptions {
    primary?: PaletteColorOptions;
    surface: PaletteColorOptions;
  }

  interface Palette {
    primary: PaletteColor;
    surface: PaletteColor;
  }

  interface PaletteColor {
    main: string;
    on?: string;
  }

  interface PaletteColorOptions {
    main: React.CSSProperties["color"];
    on?: React.CSSProperties["color"];
  }
}

export const theme = createTheme({
  palette: {
    primary: { main: "#1D1B20" },
    surface: { main: "#FEF7FF" },
  },
  components: {
    MuiButton: {
      styleOverrides: {
        root: {
          textTransform: "initial",
        },
      },
    },
  },
});

export type AppTheme = typeof theme;

export const useAppTheme = useTheme<AppTheme>;
